module.exports = __webpack_public_path__ + "static/20260428_Investor_Call_(Dial-in_Information)-16b0c52c664354b1efad74a2307a09aa.pdf";